<template>
  <v-container class="pl-0 pr-0 pt-0 pb-0">
    <v-row no-gutters class="mt-4 align-center justify-content-center">
      <v-col class="position-relative">
        <video ref="video" id="video" autoplay />
        <div 
          class="photo-button"
          @click="takePhoto">
          <v-icon size=54>mdi-camera</v-icon>
        </div>
      </v-col>
    </v-row>
    <v-sheet class="mx-auto">
      <input id="fileInput" ref="fileInput" type="file" v-on:change="onSelectFiles()" hidden />
      <v-slide-group multiple class="mt-3">
        <v-slide-item 
          class="mx-1 my-2" 
          :width="width"
          :height="height">
            <Thumbnail 
              :width="width"
              :height="height"
              clickable
              @click="selectFiles"
              >
            </Thumbnail>
        </v-slide-item>
        <v-slide-item
          v-for="picture in pictures"
          v-bind:key="picture.id"
          class="mx-1 my-2"
          :width="width"
          :height="height"
        >
          <Thumbnail
            :width="width"
            :height="height"
            :img_src="picture.src" 
            :isUploading="picture.isUploading"
            :percent="picture.percent"
          >
          </Thumbnail>
        </v-slide-item>
        <v-slide-item
          class="mx-1 my-2"
          :width="width"
          :height="height">
          <Thumbnail :width="width" :height="height" empty />
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
  </v-container>
</template>

<script>
import CameraPhoto, { FACING_MODES } from 'jslib-html5-camera-photo';
import Thumbnail from './Thumbnail.vue';

export default {
  name: "CameraComponent",
  components: {
    Thumbnail,
  },
  props: {
    documentType: {
      type: Number,
      default: 0
    },
    dataId: {
      type: Number,
      default: -1
    }
  }, 
  data () {
    return {
      count: 0,
      buttonDisabled: false,
      video: {},
      canvas: {},
      pictures: [],
      cameraPhoto: null,
      width: 84,
      height: 84,
    }
  },
  mounted() {
    // this.video = this.$refs.video;
    this.cameraPhoto = new CameraPhoto(this.$refs.video);
    let facingMode = FACING_MODES.ENVIRONMENT; // rear camera for mobile
    this.startCamera(facingMode, {});
  },
  methods: {
    startCamera (idealFacingMode, idealResolution) {
      this.cameraPhoto.startCamera(idealFacingMode, idealResolution)
        .then(() => {
          this.buttonDisabled = false;
          console.log('Camera is started!');
        })
        .catch((error) => {
          this.buttonDisabled = true;
          console.error('Camera not started!', error);
        });
    },
    startCameraMaxResolution (idealFacingMode) {
      this.cameraPhoto.startCameraMaxResolution(idealFacingMode)
        .then(() => {
          console.log('Camera is started!');
        })
        .catch((error) => {
          console.error('Camera not started!', error);
        });
    },
    takePhoto () {
      const config = {
        sizeFactor: 1
      };

      let dataUri = this.cameraPhoto.getDataUri(config);
      this.pictures.push({
        id: this.count++,
        src: dataUri,
        isUploading: false,
        percent: -1,
      })
    },
    stopCamera () {
      this.cameraPhoto.stopCamera()
        .then(() => {
          console.log('Camera stoped!');
        })
        .catch((error) => {
          console.log('No camera to stop!:', error);
        });
    },
    selectFiles () {
      document.getElementById("fileInput").click();
    },
    onSelectFiles () {
      const input = this.$refs.fileInput;
      const files = input.files;
      if (files) {
        const reader = new FileReader;
        reader.onload = e => {
          this.pictures.push({
            id: this.count++,
            src: e.target.result,
            isUploading: false,
            percent: -1,  
            }
          );
        }
        files.forEach(element => {
          reader.readAsDataURL(element);
        });
      }
    },
    upload() {
      this.pictures.forEach(element => {
        element.isUploading = true

        let formData = new FormData()
        
        formData.append('data_id', this.dataId)
        formData.append('data_doc_raw', element.src)
        formData.append('document_type_id', this.documentType)

        const config = {
          onUploadProgress: function( progressEvent ) {
              element.percent = parseInt( Math.round((progressEvent.loaded / progressEvent.total) * 100) )
          }
        }

        this.axios.post(
          '/Documents/put', 
          formData, 
          config,
          { withCredentials: true },
        )
        .then(response => {
          console.log("Uploading picture was successful")
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          element.isUploading = false
        })
      })
    }
  },
}
</script>

<style scoped>
video {
  width: 100%;
  height: calc(100vh * 0.536);
  border: thin solid #e0e7ff;
  background: rgb(125, 125, 125);
}
.photo-button {
  position: absolute;
  left: calc(50% - 2.25rem);
  bottom: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.5rem;
  height: 4.5rem;
  border: 5px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
}

.photo-button i {
  color: rgba(255, 255, 255, 0.5);
}
</style>